export default __webpack_public_path__ + "static/synergy-small-48c52aa4efa3a6c5ff38887b77b49849.png";